import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Content from "./Content";

const LayoutMain = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setSidebarOpen(false);
    }, [location.pathname]);

    const toggleSidebar = () => setSidebarOpen((prev) => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div className="d-flex">
            <Sidebar sidebarOpen={sidebarOpen} onCloseSidebar={closeSidebar} />
            <div className="flex-grow-1">
                <Navbar onToggleSidebar={toggleSidebar} />
                <Content />
            </div>
        </div>
    );
};

export default LayoutMain;